// extracted by mini-css-extract-plugin
export default {"modal":"jma-z","header":"kma-z","fields":"lma-z","error":"mma-z","disabled":"nma-z","reminderMsg":"oma-z","errorMsg":"pma-z","footer":"qma-z"};